import aponeo from './aponeo';
import { fctCheckIbanForBic } from './banking';
import { addToBasketFunctions } from './basket';
import { updatePdpBonuspoints } from './bonuspoints';
import { ShowHide_bx_tel } from './checkout';
import { _DEBUG, _urlParams } from './constants';
import { setCookie } from './cookies';
import { addDetailLinkFunctions } from './detailLink';
import { resizeHeader } from './header';
import { initLegalInfo } from './legalInfo';
import { initiateSliders } from './sliders';
import { setCursor, setSameHeight } from './utils';
import { addWishlistPzn, applyWishlistState, handleWishlistButtonClick } from './wishlist';

export function addToLeafletFunctions() {
  // init wish btn global
  $('.addtoleafletbtn-global:not(.initialized)')
    .click((event) => {
      if (_DEBUG) console.log('leaflet-->addtoleafletbtn-global:click()');
      //const self = $(event.target);
      const self = $(event.currentTarget);

      // already on the wishlist -> remove it
      if (handleWishlistButtonClick(event.currentTarget)) {
        return;
      }

      const helperUpsellingAction = $(event.currentTarget).parent().parent().parent().attr('data-dl-action');
      const helperUpsellingList = $(event.currentTarget)
        .parent()
        .parent()
        .parent()
        .attr('data-dl-addtocartupsellinglist');

      // Start GTM Wishlist tracking
      if (window['google_tag_manager']) {
        /*
     const helperElement = $(event.currentTarget).parent().children('input[name="abskt"]');

      let pageType = 'undefined pageType';
      if (typeof window['google_tag_manager']['GTM-5GNVZ2M'] === 'object'
          && typeof window['google_tag_manager']['GTM-5GNVZ2M'].dataLayer === 'object')
      {
        pageType = window['google_tag_manager']['GTM-5GNVZ2M'].dataLayer.get('pageType');
      }
      let wishlistAdd = {
        'brand': helperElement.data('brand'),
        'grossPrice': helperElement.data('gross-price'),
        'internalId': helperElement.data('internal-id'),
        'name': helperElement.data('name'),
        'pzn': String(helperElement.data('pzn')),
        'quantity': 1,
        'manufacturer': helperElement.data('manufacturer'),
        'manufacturerid': helperElement.data('manufacturerid')
      };

      if (!pageType) {
        console.log('pageType undefined');
        wishlistAdd.action = 'undefined pagetype Add to Wishlist';
      } else if (pageType === 'productdetail') {
        wishlistAdd.action = 'PDP Item Add to Wishlist';
      } else if (pageType === 'category' || (pageType.indexOf('category_subpage') !== -1)) {
        wishlistAdd.action = 'Category Page Item Add to Wishlist';
      } else if (pageType === 'search') {
        wishlistAdd.action = 'Search Results Item Add to Wishlist';
      } else if (pageType === 'service_wechselwirkungscheck') {
        wishlistAdd.action = 'Interaction Check Item Add to Wishlist';
      } else if (helperUpsellingAction) {
        wishlistAdd.action =  helperUpsellingAction;
        wishlistAdd.addToCartUpsellingList = 'Add to Wishlist "' + helperUpsellingList + '"';
      }

      console.log(('wishlistChange-->'));
      console.log(wishlistAdd)
      dataLayer.push({
        'event': 'addToWishlist',
        'wishlistChange': wishlistAdd
      });
      console.log(('<--wishlistChange'));
*/
      } // Eof GTM Wishlist tracking

      // Try to do like a customer:
      if (_DEBUG) console.log('leaflet-->getLeaflets()');
      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          todo: 'get-leaflets',
          id: 0,
        },
      }).done((response) => {
        const customer = response.customer;
        if (_DEBUG) console.log('leaflet-->customer:' + customer);

        if (customer > 0) {
          if (_DEBUG) console.log('leaflet-->customer');
          const leaflets = response.success;
          $('.leaflets-list').each((i, e) => {
            // if ($('> option', e).length > 2) {
            //   return; // already initialized
            // }

            $(e).children().remove();
            $(e).append('<option value="">Auswählen</option>');
            $(e).append('<option value="new">Neu</option>');

            for (let _i = 0; _i < leaflets.length; _i++) {
              $(e).append(
                $('<option>', {
                  value: leaflets[_i].PKcll_id,
                  text: leaflets[_i].cll_name,
                  disabled: leaflets[_i].disabled,
                }),
              );
            }
          });

          if (_DEBUG) console.log('leaflet-->customer: addtoleafletbtn:click()');
          let el = $(event.currentTarget).parent().children();
          // el.off('click');
          el.toggle(0);
        } else {
          // do action for guest & visitors
          if (_DEBUG) console.log('leaflet-->visitor/guest');
          if (_DEBUG) console.log('leaflet-->add to session');

          $.ajax({
            url: '/rpc.php?action=leaflet',
            method: 'POST',
            data: {
              todo: 'add-to-session',
              id: self.val(),
            },
          }).done(() => {
            addWishlistPzn(event.currentTarget.value);

            self.popover({
              content: 'Der Artikel ist jetzt auf ihrem Merkzettel',
              placement: 'top',
              title: 'Merkzettel',
              trigger: 'manual',
            });

            self.popover('show');

            $('body').one('click', () => {
              self.popover('hide');
            });
          });
        }
      });
    })
    .addClass('initialized');

  applyWishlistState();

  initLeafletSelect();
}

export function initLeafletSelect(root) {
  if (typeof root == 'undefined') {
    root = $('body');
  }

  $('.leaflets-list:not(.initialized)', root)
    .change(function () {
      if (_DEBUG) console.log('leaflet-->initLeafletSelect()');

      if (!$(this).val()) {
        if (_DEBUG) console.log('leaflet--> initLeafletSelect()-->false');
        return false;
      }

      const self = $(this).parent();
      setCursor('wait');
      $(this).parent().prop('id', $(this).val());

      if (_DEBUG) {
        console.log($(this));
        console.log('leaflet-->initLeafletSelect() todo:add-product');
        console.log('leaflet-->initLeafletSelect() id:' + $(this).val());
        console.log('leaflet-->initLeafletSelect() pzn:' + $(this).parent().children('.addtoleafletbtn-global').val());
      }

      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          todo: 'add-product',
          id: $(this).val(),
          pzn: $(this).parent().children('.addtoleafletbtn-global').val(),
        },
      })
        .done((response) => {
          $('#' + response.id)
            .children()
            .toggle(0);

          $('#' + response.id)
            .children('.leaflets-list')
            .val('');

          $('#' + response.id).prop('id', '');

          if (!response.success) {
            alert('Der Artikel konnte nicht auf dem Merkzettel gespeichert werden');
          } else {
            addWishlistPzn($(this).parent().children('.addtoleafletbtn-global').val());

            self.popover({
              content: 'Der Artikel ist jetzt auf ihrem Merkzettel',
              placement: 'top',
              title: 'Merkzettel',
              trigger: 'manual',
            });

            self.popover('show');

            $('body').one('click', function () {
              self.popover('hide');
            });
          }
        })
        .always(function () {
          setCursor('default');
        });
    })
    .addClass('initialized');
}

//JS for Leaflet
const leafletTimer = {};

export function saveLeaflet(leafletId) {
  clearTimeout(leafletTimer[leafletId]);
  leafletTimer[leafletId] = setTimeout(function () {
    let products = [];
    $('#coupon-action-' + leafletId)
      .find('div[id^="product"]')
      .each(function () {
        products[products.length] = {
          pro_pzn: $(this).prop('id').split('-')[1],
          quantity: $(this).find('.quantity-display').val(),
        };
      });
    $.ajax({
      url: '/rpc.php?action=leaflet',
      method: 'POST',
      data: {
        id: leafletId,
        products: JSON.stringify(products),
        todo: 'update',
      },
    }).done(function (res) {
      let response = jQuery.parseJSON(res);
      if (!response['success']) {
        alert('Speichern der neuen Anzahl ist fehlgeschlagen.');
      }
    });
  }, 3000);
}

export default function () {
  $(document).ready(function () {
    /**
     * Clickfunction on PDP to get manufacturer email|website via Ajax/Soap WEB-4557
     */
    if ($('._gpsr').length) {
      $('._gpsr').click(function () {
        let pzn = $('._gpsr').data('gpsrpzn');

        if (_DEBUG) console.log('Get GPSR data for pzn ' + pzn);

        setCursor('wait');
        $.ajax({
          url: '/rpc.php?action=manufacturerdata',
          method: 'POST',
          data: {
            p: pzn,
          },
        }).done(function (response) {
          setCursor('default');
          if (_DEBUG) console.log(response);

          if (isNaN === response.success) {
            return false;
          }

          $('._gpsr').hide(800);
          $('._gpsr').html('elektronische Adresse: ' + response.email + ' | ' + response.website);
          $('._gpsr').show(800);
        });

        return false;
      });
    }

    let logout = _urlParams.get('logoutinfo');
    if (logout != null) {
      if (typeof amazon !== 'undefined') {
        console.log('signout req amz');
        amazon.Pay.signout();
      }
    }

    /** Mehr Produkte laden auf Ratgeber-Seiten */
    if ($('#advisor-more-products-button').length) {
      $('#advisor-more-products-button').on('click', function () {
        $('#advisor-more-products-content').removeClass('d-none');
        $('#advisor-more-products-button-wrapper').addClass('d-none');
      });
    }

    /** Direkt den richtigen Ratgeber Tab aufmachen */
    if ($('#products-tab').length && $('#article-tab').length) {
      console.log('Tab vorhanden');
      const currentUrl = document.location.toString();
      if (currentUrl.match('#')) {
        console.log('Tab aufmachen');
        $('.nav-tabs a[href="#' + currentUrl.split('#')[1] + '"]').tab('show');
      }

      /** "Weitere Produkte" im Empfehlungsteaser soll auch den Tab aufmachen. */
      $('a[data-teaser="more"]').click(function () {
        $('.nav-tabs a[href="#products"]').tab('show');
        const productsTab = $('#products-tab');
        $('html,body').animate({ scrollTop: productsTab.offset().top }, 'slow');
      });
    }

    $('.btn-leaflet-rename').click(function () {
      $(this).parent().siblings('js-leaflet-name').children().toggle(0);
      return false;
    });

    $('.btn-leaflet-save-name').click(function () {
      $(this).prop('disabled', true);
      const el = $(this).parent().prev();
      setCursor('wait');

      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          id: el.prop('name').split('_')[1],
          name: el.val(),
          todo: 'rename',
        },
      }).done(function (response) {
        setCursor('default');

        $('div[data-leafletId="#coupon-action-' + response.id + '"] button[name="rename"]').prop('disabled', false);

        if (response.success == false) {
          alert(
            'Umbenennen des Merkzettels schlug fehl. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.',
          );
          return;
        }

        $('#leafletname-' + response.id).text(
          $('#leafletname-' + response.id)
            .next()
            .find('input[name^="name_"]')
            .val(),
        );

        $('div[data-leafletId="#coupon-action-' + response['id'] + '"] js-leaflet-name')
          .children()
          .toggle(0);

        $('.js-leafletSortButton').val('');
      });

      return false;
    });

    $('.btn-leaflet-delete').click(function () {
      const name = $(this).closest('.page-nav-menu-item').children().find('.js-leaflet-name').text();

      if (!confirm('"' + name + '" wirklich löschen?')) {
        return false;
      }

      setCursor('wait');

      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          id: $(this).val(),
          todo: 'delete',
        },
      }).done(function (response) {
        setCursor('default');

        if (isNaN === response.success) {
          alert('Löschen des Merkzettels schlug fehl. Bitte versuchen Sie es zu einem späteren Zeitpunkt noch einmal.');
          return false;
        }

        $('#leaflet-' + response.success).slideUp();
      });

      return false;
    });

    $('.btn-quantity-increase').click(function () {
      let element = $(this).siblings('.display-quantity');
      if (Number(element.val()) < Number($(this).siblings('.max-sales').val())) {
        element.val(Number(element.val()) + 1);
        $('#btn-save').show();
      }
    });

    $('.btn-quantity-decrease').click(function () {
      let element = $(this).siblings('.display-quantity');
      if (Number(element.val()) > 1) {
        element.val(Number(element.val()) - 1);
        $('#btn-save').show();
      }
    });

    $('div[id^=leaflet-]').each(function () {
      $.ajax({
        url: '/rpc.php?action=leaflet',
        method: 'POST',
        data: {
          id: $(this).prop('id').split('-')[1],
          todo: 'get-products',
        },
      }).done(function (response) {
        let products = response.success;
        const node = $('#coupon-action-' + response.id + ' > .coupon-information > .cart-product-list');

        for (let i = 0; i < products.length; i++) {
          node.append(products[i]);
        }

        addToBasketFunctions();

        node.find('.btn-remove').click(function () {
          setCursor('wait');
          $.ajax({
            url: '/rpc.php?action=leaflet',
            method: 'POST',
            data: {
              todo: 'remove-product',
              leaflet: $(this).parents('div[id^=leaflet-]').prop('id').split('-')[1],
              id: $(this).val(),
            },
          }).done(function (response) {
            setCursor('default');

            if (response.id) {
              $('#product-' + response.id).slideUp(1000);
            }
          });

          return false;
        });

        $('#coupon-action-' + response.id + ' .quantity-increase').click(function () {
          let element = $(this).parents('.input-group').children('.quantity-display');
          if (Number(element.val()) < Number(element.parent().children('.quantity-max').val())) {
            element.val(Number(element.val()) + 1);
            saveLeaflet(response.id);
          }
        });

        $('#coupon-action-' + response.id + ' .quantity-decrease').click(function () {
          let element = $(this).parents('.input-group').children('.quantity-display');
          if (Number(element.val()) > Number(element.parent().children('.quantity-min').val())) {
            element.val(Number(element.val()) - 1);
            saveLeaflet(response.id);
          }
        });
      });
    });

    // Merkzettel sortieren WEB-1511
    const leafletSortButton = $('.js-leafletSortButton');
    const $leafletList = $('.js-eaflet-list');
    const $leaflets = $leafletList.find('.js-leaflet');

    if (leafletSortButton.length && $leaflets.length) {
      let descending = false;

      const sortLexicographical = function (a, b) {
        const leafletNameA = $(a).find('[id^=leafletname-]').html();
        const leafletNameB = $(b).find('[id^=leafletname-]').html();
        if (descending) {
          return leafletNameB.localeCompare(leafletNameA);
        } else {
          return leafletNameA.localeCompare(leafletNameB);
        }
      };

      const sortLastEdit = function (a, b) {
        const timestampA = $(a).data('lastEdit');
        const timestampB = $(b).data('lastEdit');
        if (timestampA > timestampB) return -1;
        if (timestampA < timestampB) return 1;
        return 0;
      };

      leafletSortButton.change(function (e) {
        switch (this.value) {
          case 'sortLexicographicalAsc':
            descending = false;
            $leaflets.sort(sortLexicographical);
            break;
          case 'sortLexicographicalDesc':
            descending = true;
            $leaflets.sort(sortLexicographical);
            break;
          case 'sortLastEditDesc':
            $leaflets.sort(sortLastEdit);
            break;
        }

        // Re-order elements in DOM
        $leafletList.append($leaflets);
      });
    }

    addToLeafletFunctions();
    addToBasketFunctions();
    addDetailLinkFunctions();

    $('#ds3, #ds4, #ds5').change(function () {
      $(this).parents('form').submit();
    });

    $('#ds5_teaser_deactivate').change(function (event) {
      $('#ds5_modal_deactivate').modal('show');
      $('#ds5_teaser_deactivate').prop('checked', true);

      event.preventDefault();
    });

    $('.teaser_dyn').each(function () {
      $.ajax({
        url: '/rpc.php?action=teaser',
        method: 'POST',
        data: {
          id: $(this).prop('id').split('-')[1],
        },
      }).done(function (response) {
        $('#teaser-' + response.id).append(response.value);
      });
    });

    // Checkout Trust modules hide if consent is allready
    if ($('input[name="newsletter"]').length) {
      $.ajax({
        url: '/rpc.php?action=check-permission',
        method: 'POST',
        data: {
          module: 'newsletter',
        },
      }).done(function (response) {
        if (response.confirmation) {
          $('#input-03').parent().slideUp();
        }
      });
    }

    if ($('input[name="confirm_dhl"]').length) {
      $.ajax({
        url: '/rpc.php?action=check-permission',
        method: 'POST',
        data: {
          module: 'dhl-tracking',
        },
      }).done(function (response) {
        if (response.confirmation) {
          $('#confirm_dhl').parent().slideUp();
        }
      });
    }

    if ($('input[name="confirmTrustPharmaHera_Marketingzwecke"]').length) {
      $.ajax({
        url: '/rpc.php?action=check-permission',
        method: 'POST',
        data: {
          module: 'ph-marketing',
        },
      }).done(function (response) {
        if (response.confirmation) {
          $('#confirmTrustPharmaHera_Marketingzwecke').parent().slideUp();
        }
      });
    }

    let PaymentMethodActive = $('input[name=PayId]:checked').val();
    if (PaymentMethodActive == 1) {
      $('#bonuspoints_calc').hide();
      $('#bonuspoints_0').show();
    } else {
      $('#bonuspoints_calc').show();
      $('#bonuspoints_0').hide();
    }

    $('input[name=PayId]').change(function () {
      console.log('Handler for .change() called.');
      PaymentMethodActive = $('input[name=PayId]:checked').val();
      console.log('PaymentId is ' + PaymentMethodActive);

      if (PaymentMethodActive == 1) {
        $('#bonuspoints_calc').hide();
        $('#bonuspoints_0').show();
      } else {
        $('#bonuspoints_calc').show();
        $('#bonuspoints_0').hide();
      }
    });

    // WerbeOverlay in Checkout:Liefert
    if ($('input#shipping_48').length && $('#shipping_48').data('sameday') == '1') {
      // BX Push Popup if BX(via Liefery) is possible and also if it is SAMEDAY
      if ($('#shipping_48').data('loyalitystate') > '2' && $('input#check-prio-delivery').length) {
        // WEB-1218 : Bei Bonusprogrammstatus Diamant soll möglichst "kostenlose" orderPrio beworben werden
        $('#checkoutOrderpriorityModal').modal('show');
      } else {
        // Wenn kein Diamant, dann Sameday bewerben
        if ($('input#shipping_46\\|3').is(':checked') == false) {
          // ...und noch nicht ausgewählt
          $('#checkoutBxPushModal').modal('show');
        }
      }
    } else if ($('input#check-prio-delivery').length) {
      // Wenn BX/Sameday(via Liefery) nicht möglich ist .....
      // Order Priority Popup wenn Orderprio möglich(angezeigt)
      // Order Priority ist verfügbar
      if ($('input#check-prio-delivery').is(':checked') == false) {
        // ...und noch nicht ausgewählt
        $('#checkoutOrderpriorityModal').modal('show');
      }
    }
    // Eof WerbeOverlay in Checkout:Liefert

    // Start Order Priority Popup & SamedayPush Popup
    $('#checkOrderPriority1').on('click touch', function () {
      $('#shipping_1').prop('checked', true);
      $('#check-prio-delivery').prop('checked', true);
    });

    $('#checkOrderPriority2').on('click touch', function () {
      $('#shipping_1').prop('checked', true);
      $('#check-prio-delivery').prop('checked', true);
    });

    $('#checkBxPush1').on('click touch', function () {
      $('#shipping_48').prop('checked', true);
      ShowHide_bx_tel();
    });

    $('#checkBxPush2').on('click touch', function () {
      $('#shipping_48').prop('checked', true);
      ShowHide_bx_tel();
    });
    // Eof Order Priority Popup & SamedayPush Popup

    updatePdpBonuspoints();
    initiateSliders();
    initLegalInfo();
    fctCheckIbanForBic();

    // Marken A-Z links toggled by select options
    $('.js-toggle-brand-overview').on('change', function () {
      const letter = $(this).find(':selected').val();
      // $('.list-wrapper').removeClass('active');
      // $('#list-' + letter).addClass('active');
      window.location.href = '#list-' + letter;
    });

    // Since Bootstrap v4 toggling of multiple targets is removed
    // Close header and show form
    $('.js-account-toggle-data').on('click touch', function () {
      $(this).parent('div').collapse('toggle');
    });

    // Close form and show header
    $('.js-account-toggle-data-header').on('click touch', function () {
      const header = $(this).closest('.apn-content-block').find('.apn-account-current-data');
      header.collapse('toggle');

      if (!header.prev().isInViewport()) {
        aponeo.scrollTop(header.prev());
      }
    });

    const accordionForm = $('.form-shipping-address');

    if (accordionForm.length) {
      const $accordionFormCollapses = $('.collapse', accordionForm);

      $accordionFormCollapses
        .on('hide.bs.collapse', function (e) {
          $(this)
            .find(':input')
            .each(function () {
              $(this).prop('disabled', true);
            });
        })
        .on('shown.bs.collapse', function (e) {
          $(this)
            .find(':input')
            .each(function () {
              // is collapse was has this input visible? => important by nested collapse
              if ($(this).closest('.collapse').is(':hidden') === false) {
                $(this).prop('disabled', false);
              }
            });
        });

      // disable all collapsed input fields at startup
      $(':input', $accordionFormCollapses).each(function () {
        $(this).prop('disabled', true);
      });

      // Disable and handle Shipping-Toggle radios if customer is new
      if (accordionForm.hasClass('js-new-customer')) {
        const $newCustomerForm = $('#new-customer-location-form');
        const $shippingToggleRadios = $('input[type="radio"][id^="shipping-toggle"]');
        const $requiredInputs = $newCustomerForm.find('input[required]');
        // const requiredInputsVanilla = document
        //   .getElementById('new-customer-location-form')
        //   .querySelectorAll('input[required]');
        let isDisabled = [];

        $shippingToggleRadios.each((index, toggleRadio) => {
          const $toggleRadio = $(toggleRadio);
          const hasDisabledState = $toggleRadio.attr('disabled');

          if (typeof hasDisabledState !== 'undefined' && hasDisabledState !== false) {
            isDisabled.push('true');
          } else {
            isDisabled.push('false');
          }

          $toggleRadio.addClass('disabled').prop('disabled', true);
        });

        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            let $validInputs = $requiredInputs.filter('.is-valid');

            if ($requiredInputs.length === $validInputs.length) {
              $newCustomerForm.addClass('is-valid');
            }

            if ($newCustomerForm.hasClass('is-valid')) {
              $shippingToggleRadios.each((index, toggleRadio) => {
                const $toggleRadio = $(toggleRadio);
                if (isDisabled[index] === 'false') {
                  $toggleRadio.removeClass('disabled').prop('disabled', false);
                }
              });
            }
          });
        });

        observer.observe($newCustomerForm[0], {
          attributes: true,
          attributeFilter: ['class'],
        });

        $requiredInputs.each((index, input) => {
          observer.observe(input, {
            attributes: true,
            attributeFilter: ['class'],
          });
        });
      }

      $('.edit-link', accordionForm).on('click', function () {
        $($(this).data('inputselector')).prop('checked', true).change();
      });
    }

    // Resize page header after height changes
    $('#apn-header-search').on('hidden.bs.collapse shown.bs.collapse', function () {
      resizeHeader();
    });

    // Allow immediate input after showing search
    $('#apn-header-search').on('shown.bs.collapse', function () {
      $('#apn-header-search input[name="q"]').focus();
      // hide navigation
      if ($('#apn-main-navigation-off-canvas-wrapper').hasClass('off-canvas-opened')) {
        $('.js-toggle-off-canvas').click();
      }
    });

    // Resize Page header when document loaded
    $(document).ready(resizeHeader);
    $(window).resize(resizeHeader);

    $('._apn-teaser-close-remember').on('click touch', function () {
      if (_debug) {
        console.log('hide and remember teaser:' + $(this).data('target'));
      }

      $($(this).data('target')).hide(700, function () {
        resizeHeader();
      });

      if ($(this).data('target')) {
        setCookie('hideTeaser' + $(this).data('teaserid'), '1', 5, '/');
      }
    });

    $('.filter-item input').on('click touch', function () {
      if ($(this).data('url')) {
        window.location.href = $(this).data('url');
      } else if ($(this).data('base64')) {
        let jsLinkUrl = atob($(this).data('base64'));
        window.location.href = jsLinkUrl;
      }
    });

    if ($('._show_before').length) {
      $('._show_before').each(function (index, element) {
        console.log('vvvvvvvvvv');
        console.log($(this));

        let $showto = $(this).data('showtargetid');
        if ($('#' + $showto).length) {
          let $element = $(this).removeClass('_show_before').addClass('_show_before_show');
          $element.insertBefore('#' + $showto);
        }
      });
    }

    if ($('._show_after').length) {
      $('._show_after').each(function (index, element) {
        let $showto = $(this).data('showtargetid');

        if ($('#' + $showto).length) {
          let $element = $(this).removeClass('_show_after').addClass('_show_after_show');
          $element.insertAfter('#' + $showto);
        }
      });
    }

    $('._js_link').on('click touch', function (el) {
      const jsLinkUrl = $(this).data('url');

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl,
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            location.href = jsLinkUrl;
          },
          eventTimeout: 2000,
        });
      } else {
        location.href = jsLinkUrl;
      }
    });

    $('._js_link_blank').on('click touch', function (el) {
      // go to the same url without any GET-Params
      const jsLinkUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl + ' (blank)',
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            location.href = jsLinkUrl;
          },
          eventTimeout: 2000,
        });
      } else {
        location.href = jsLinkUrl;
      }
    });

    $('._js_link_external').on('click touch', function (el) {
      const jsLinkUrl = $(this).data('url');

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl + ' (external)',
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            window.open(jsLinkUrl);
          },
          eventTimeout: 2000,
        });
      } else {
        window.open(jsLinkUrl);
      }
    });

    $('._js_link64').on('click touch', function (el) {
      const jsLinkUrl = atob($(this).data('base64'));

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl,
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            location.href = jsLinkUrl;
          },
          eventTimeout: 2000,
        });
      } else {
        location.href = jsLinkUrl;
      }
    });

    $('._js_link64_external').on('click touch', function (el) {
      const jsLinkUrl = atob($(this).data('base64'));

      if (window['google_tag_manager']) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: 'jsLinkClick',
          jsLinkUrl: jsLinkUrl + ' (external)',
          jsLinkInnerText: el.target.innerText ? el.target.innerText.replace(/[^\w\s]/gi, '') : '',
          eventCallback: function () {
            window.open(jsLinkUrl);
          },
          eventTimeout: 2000,
        });
      } else {
        window.open(jsLinkUrl);
      }
    });

    $('._pdf_option_blank').on('click touch', function () {
      const formname = $(this).data('formname');
      $('form[name=' + formname + ']').submit();
    });

    $('#breadcrump_backicon').on('click touch', function () {
      // go to Back
    });

    // Hide empty recommendations container
    // select .recommendation with a child .swiper-wrapper that has no children
    $('.recommendations:has(.swiper-wrapper:not(:has(*)))').each(function () {
      $(this).hide();
    });

    // AJAX product slider
    $('.recommendations.apn-teaser[data-category]').each(function () {
      const params = {
        action: 'products',
        category: $(this).data('category'),
      };

      if ($(this).data('maxcount')) {
        params.maxcount = $(this).data('maxcount');
      }

      const self = this;

      // setup valid html structure
      if (!$('.swiper-wrapper', self).length) {
        $('.apn-teaser-product-slider', self).append(
          '<div class="swiper-container"><div class="swiper-wrapper"></div></div>',
        );
      }

      if (!$('.swiper-button-prev, .swiper-button-next', self).length) {
        $('.apn-teaser-product-slider', self).append(
          '<div class="swiper-button-prev d-none d-lg-block"></div>' +
            '<div class="swiper-button-next d-none d-lg-block"></div>',
        );
      }

      // save vars for the ajax callbacks
      const elem = $('.swiper-container', this);
      $.ajax({
        url: '/rpc.php',
        data: params,
        method: 'GET',
      }).done(function (response) {
        $('.swiper-wrapper', elem).html(response);

        if (!$('.swiper-wrapper > *', elem).length) {
          return; // got no products -- do not show swiper
        }

        $(self).show();

        const maxSlides = $(elem).hasClass(' max-slides-4') ? 4 : 5;
        const numberOfSlides = $(elem).children('.swiper-wrapper')[0].childElementCount;

        new Swiper(elem, {
          slidesPerView: 'auto',
          slidesPerGroup: maxSlides,
          breakpoints: {
            991: {
              slidesPerGroup: 1,
            },
          },
          navigation: {
            nextEl: $('.apn-teaser-product-slider .swiper-button-next', self),
            prevEl: $('.apn-teaser-product-slider .swiper-button-prev', self),
          },
        });

        if (numberOfSlides <= maxSlides) {
          $(elem).siblings('.swiper-button-next').removeClass('d-lg-block');
          $(elem).siblings('.swiper-button-prev').removeClass('d-lg-block');
        }

        // equalizer setup after adding content
        setSameHeight(elem, '.apn-product-list-item-header');

        addToLeafletFunctions();
        addToBasketFunctions();
        addDetailLinkFunctions();
      });
    });

    $('#findorder_submit').click(function () {
      // $(this).prop('disabled', true);

      const orderid = $('#findorder_id').val();
      console.log('Suche nach' + orderid);

      if (orderid.length > 2) {
        // $('findorder_submit').disable(true);
        $('#findorder_submit').attr('disabled', true);

        setCursor('wait');
        $.ajax({
          url: '/rpc.php?action=findorder_state',
          method: 'POST',
          data: {
            id: orderid,
          },
        }).done(function (response) {
          setCursor('default');
          console.log('mach wieder an!');
          // $(this).prop('disabled', true);

          console.log(response.html);
          if (response.success != false) {
            $('#findorder_response').html(response.html);
          } else {
            $('#findorder_response').html('');
          }

          $('#findorder_submit').attr('disabled', false);
        });
      } else {
        $('#findorder_response').html('<div class="txt-white">Bitte prüfen Sie Ihre Eingabe.</div>');
      }

      return false;
    });

    $('#findorder_page_submit').click(function () {
      // $(this).prop('disabled', true);

      const orderid = $('#findorder_id').val();
      console.log('Suche nach' + orderid);

      if (orderid.length > 2) {
        // $('findorder_submit').disable(true);
        $('#findorder_submit').attr('disabled', true);
        setCursor('wait');
        $('#findorder_response').hide(300);
        $('#findorder_response').html('');

        $.ajax({
          url: '/rpc.php?action=findorder_state&page=orderstate_check',
          method: 'POST',
          data: {
            id: orderid,
          },
        })
          .done(function (response) {
            setCursor('default');

            console.log(response.html);
            if (response.success != false) {
              $('#findorder_response').html(response.html);
            } else {
              $('#findorder_response').html('');
            }
          })
          .always(() => {
            $('#findorder_submit').attr('disabled', false);
            $('#findorder_response').show(300);
          });
      } else {
        $('#findorder_response').html('<div class="txt-white">Bitte prüfen Sie Ihre Eingabe.</div>');
      }

      return false;
    });
  });
}
